import React from 'react';
import PropTypes from 'prop-types';
import Affiliate from './affiliate';

class ProfileContainer extends React.Component {
  render() {
    return (
      <div >
        <span />
        <div className="main-content shadow-none">
          
            <Affiliate />
        </div>
      </div>
    );
  }
}

ProfileContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};


export default ProfileContainer;
